import angular from "../../../_snowpack/pkg/angular.js";
import {
  Accounts,
  Employments,
  Records
} from "../../../_snowpack/link/dist/@salaxy/core/salaxy-lib-core.js";
function isWorkflowPayload(model) {
  return model.workflowData !== void 0;
}
function isMessagesListItem(model) {
  return model.messages !== void 0;
}
export class WorkflowBadgeProController {
  constructor(uiHelpers, proService, uploadService) {
    this.uiHelpers = uiHelpers;
    this.proService = proService;
    this.uploadService = uploadService;
    this._events = [];
  }
  $onInit() {
  }
  get events() {
    if (isWorkflowPayload(this.model)) {
      const eventsOfTypes = (this.model.workflowData?.events ?? []).filter((x) => !this.wfTypes || this.wfTypes.length == 0 || this.wfTypes.indexOf(x.type) >= 0);
      this.modifyArray(eventsOfTypes, this._events);
    } else if (isMessagesListItem(this.model)) {
      const eventsOfTypes = [];
      for (const msg of this.model.messages) {
        const eventOfType = this.toWorkflowEvent(msg);
        if (!this.wfTypes || this.wfTypes.length == 0 || this.wfTypes.indexOf(eventOfType.type) >= 0) {
          eventsOfTypes.push(eventOfType);
        }
      }
      this.modifyArray(eventsOfTypes, this._events);
    } else {
      this.modifyArray([], this._events);
    }
    return this._events;
  }
  async showEventDetails(original) {
    const ajax = await this.proService.getAjaxFor(this.accountId);
    const api = this.getApi(ajax);
    const records = new Records(ajax);
    const ensureItem = () => {
      if (isMessagesListItem(this.model)) {
        return api.getSingle(this.model.id);
      } else {
        return Promise.resolve(this.model);
      }
    };
    const getWorkflowEvent = () => {
      if (original?.id) {
        return ensureItem().then((item) => {
          return Promise.resolve(item.workflowData.events.find((x) => x.id == original.id)).then((result) => {
            if (!result) {
              return {event: original, record: null};
            }
            if (!result.record) {
              return {event: result, record: null};
            }
            return records.getSingle(result.record).then((record) => {
              return {event: result, record};
            });
          });
        });
      }
      return Promise.resolve({event: original, record: null});
    };
    getWorkflowEvent().then((result) => {
      this.uiHelpers.openEditDialog("salaxy-components/modals/workflow/WorkflowBadgeDetails.html", result, {
        getAttachmentDownloadUrl: (attachment) => `${ajax.getApiAddress()}/files/stream/${attachment?.contentId}?access_token=${ajax.getCurrentToken()}`,
        getAttachmentIcon: (attachment) => this.getAttachmentIcon(attachment)
      });
    });
  }
  getAttachmentIcon(attachment) {
    return this.uploadService.getFileIcon(attachment?.fileName);
  }
  getApi(ajax) {
    switch (this.entityType) {
      case "employment":
        return new Employments(ajax);
      case "account":
        return new Accounts(ajax);
      default:
        throw new Error("Entity type " + this.entityType + " not implemented.");
    }
  }
  toWorkflowEvent(messageString) {
    if (!messageString) {
      return {};
    }
    const uiStartX = messageString.indexOf("(Ui");
    const uiEndX = messageString.indexOf("):", uiStartX + 3);
    const type = messageString.substring(0, uiStartX - 1) || "";
    const ui = messageString.substring(uiStartX + 3, uiEndX).toLowerCase();
    let rest = messageString.substring(uiEndX + 3);
    const messageEndX = rest.lastIndexOf("(");
    const message = rest.substring(0, messageEndX).trim();
    rest = rest.substring(messageEndX + 1);
    rest = rest.substring(0, rest.length - 1);
    let id = "";
    const idx = rest.lastIndexOf(" id ");
    if (idx >= 0) {
      id = rest.substring(idx + 4);
      rest = rest.substring(0, idx);
    }
    let assignedTo = "";
    const aIdx = rest.lastIndexOf(" to ");
    if (aIdx >= 0) {
      assignedTo = rest.substring(aIdx + 4);
      rest = rest.substring(0, aIdx);
    }
    let time = "";
    const tIdx = rest.lastIndexOf(" at ");
    if (tIdx >= 0) {
      time = rest.substring(tIdx + 4);
      rest = rest.substring(0, tIdx);
      time = time.replace(" ", "T") + "Z";
    }
    const user = rest;
    return {
      id,
      type,
      ui,
      user,
      assignedTo,
      message,
      time
    };
  }
  modifyArray(source, target) {
    if (angular.equals(source, target)) {
      return;
    }
    target.splice(0, target.length);
    target.push(...source);
  }
}
WorkflowBadgeProController.$inject = [
  "UiHelpers",
  "ProService",
  "UploadService"
];
